import Logger from '../lib/logger';

class MultiModal extends HTMLElement {
  #NAME = 'MultiModal'
  #modal
  #productModal

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    //
    this.#modal = this.querySelector('bundler-modal');
    this.#productModal = document.querySelector('product-modal bundler-modal');
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    this.#modal.addEventListener('modalevent', (e) => this.#onModalEvent(e));
  }

  openModal = () => {
    Logger.info(`${this.#NAME} > openModal`);
    this.#modal.dataset.show = 'true';
  }
  
  #onModalEvent(e) {
    Logger.info(`${this.#NAME} > onModalEvent`, e.detail);
    //
    if (e.detail.name === 'confirm') {
      document.querySelector(`[data-launch-modal][data-product-id="${this.#productModal.dataset.productId}"]`)?.click();
      this.#modal.dataset.show = 'false';
    } else if (e.detail.name === 'dismiss') {
      this.#modal.dataset.show = 'false';
    }
    
  }
}

customElements.define('multi-modal', MultiModal);